import { ServiceMaker, methods, services } from "@/services";

export const getTicketList = () =>
    ServiceMaker("/servicerequest/ticket/list", methods.GET, services.master);
export const updateTicket = (id, data) =>
    ServiceMaker(
        `/servicerequest/ticket/update/${id}`,
        methods.PUT,
        services.master,
        data,
    );
export const getCategoryList = () =>
    ServiceMaker("/servicerequest/category/list", methods.GET, services.master);
export const getAdminList = (params = {}) => {
    const query = new URLSearchParams(params).toString();
    const url = query
        ? `/cap/users/admin/list?${query}`
        : "/cap/users/admin/list";
    return ServiceMaker(url, methods.GET, services.master);
};
export const createTicket = (payload) =>
    ServiceMaker(
        "/servicerequest/ticket/create",
        methods.POST,
        services.master,
        payload,
    );
export const escalateTicket = (id, payload) =>
    ServiceMaker(
        `/servicerequest/ticket/escalate/${id}`,
        methods.POST,
        services.master,
        payload,
    );
